export function registerComponents(Vue: any, components: object, includeComponents?: string[]) {
    for (let key in components) {
        if (!includeComponents || includeComponents.includes(key)) {
            registerComponent(Vue, key, (<any>components)[key]);
        }
    }
}

export function registerComponent(Vue: any, key: string, component: any) {
    Vue.component(component.name || key, component);
}

